import React, { useState } from "react";
import faqData from "../../data/faq.json";

export default function Section2() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container-1280 Section2 w-full pt-[35px] pb-[70px] px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
      <h1 className="md:text-[34px] text-[24px] leading-[32px] md:leading-[41px] font-bold text-[#DA2125] text-center">
        Frequently Asked Questions
      </h1>

      <div className="pt-10 faq">
        {faqData.map((faq, index) => (
          <div key={index} className="faq-item border-b border-[#e3e3e3]">
            <div
              onClick={() => toggleFaq(index)}
              className={`question p-[16px_60px_15px_25px] relative rounded-tl-[3px] rounded-tr-[3px] text-[14px] font-[600] font-open cursor-pointer 
                hover:bg-[#f8f8f8] hover:text-[#111]
                before:content-[''] before:absolute before:w-[10px] before:h-[2px] before:bg-[#ddd] before:top-1/2 before:right-[31px] before:transition-transform before:duration-300 
                after:content-[''] after:absolute after:w-[10px] after:h-[2px] after:bg-[#ddd] after:top-1/2 after:right-[25px] after:transition-transform after:duration-300
                ${
                  openIndex === index
                    ? "before:rotate-[-45deg] after:rotate-45  border-b bg-[#f8f8f8] text-[#111] border-[#e3e3e3] border-solid"
                    : "before:rotate-45 after:-rotate-45 bg-white text-[#505050]"
                }`}
            >
              {faq.question}
            </div>


            {/* Answer */}
            <div
              className={`answer px-[25px] bg-[#f8f8f8]  text-[#535353] font-open transition-all duration-300 ease-in-out ${
                openIndex === index
                  ? "max-h-[500px] pt-[20px] pb-[45px]"
                  : "max-h-0"
              }`}
            >
              {openIndex === index && <p>{faq.answer}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
